import { render, staticRenderFns } from "./xgPersonal.vue?vue&type=template&id=4553f036&scoped=true&"
import script from "./xgPersonal.vue?vue&type=script&lang=js&"
export * from "./xgPersonal.vue?vue&type=script&lang=js&"
import style0 from "./xgPersonal.vue?vue&type=style&index=0&id=4553f036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553f036",
  null
  
)

export default component.exports